"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "wrap", {
  enumerable: true,
  get: function get() {
    return _Field.wrap;
  }
});
Object.defineProperty(exports, "wrapWith", {
  enumerable: true,
  get: function get() {
    return _Field.wrapWith;
  }
});
exports["default"] = void 0;

var _Field = _interopRequireWildcard(require("../Field"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _Field["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/Field.js
// module id = 488
// module chunks = 0